import { mapGetters } from 'vuex';

export default {
    name: 'additionalServices',
    inject: ['$eventBus'],
    props: ['zipcode', 'price', 'propertyType', 'yearBuilt', 'state', 'city'],
    mounted() {
        this.initializeAdditionalService();
        this.show = this.getSplit('movoto-dpp-mortgagesec-open-cw-803', 'default');
    },
    data() {
        return {
            loadAdditionalService: false,
            show: true,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
    },
    methods: {
        initializeAdditionalService() {
            if (this.loadAdditionalService) {
                return;
            }
            this.loadAdditionalService = true;
            let _eventBus = this.$eventBus;
            (function (w, d, s, o, f, js, fjs) {
                w['CM-ASWidget'] = o;
                w[o] =
                    w[o] ||
                    function () {
                        (w[o].q = w[o].q || []).push(arguments);
                    };
                (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
                js.id = o;
                js.src = f;
                js.async = 1;
                fjs.parentNode.insertBefore(js, fjs);
                js.onload = () => {
                    $('.cm-addt-services-title').parent().css({ display: 'none' });
                    $('#cmasw').on('click', (e) => {
                        let linkName = e.target.href || e.target.parentElement.href || '';
                        _eventBus.$emit('ga', { en: 'additional_services_session', ec: 'partner', el: 'cordless', props: { link_name: linkName } });
                    });
                };
            })(window, document, 'script', 'asw', 'https://cdn.cordlessmedia.com/additional-services/v2/widget.js');
            asw('message', {
                pid: '89984',
                zip: this.zipcode || '',
                state: this.state || '',
                city: this.city || '',
                address: this.glb.geo.address || '',
                isMobile: this.glb.isMobile,
                ownership: this.glb.rentals ? 'rent' : 'own',
                apt: '',
                price: this.price || '',
                // homeType: this.propertyType || '',
                ageOfHome: this.yearBuilt ? new Date().getFullYear() - this.yearBuilt : '',
            });
        },
        toggle() {
            this.show = !this.show;
        },
    },
};
